<div mat-dialog-title>
  <div>{{ data.title }}</div>
  <div class="close-icon-container" (click)="onClick(false)">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content data-cy="dialog-content">
  @if (data.line1) {
    <p class="line-1" [ngStyle]="data.line1Color && { color: data.line1Color }">
      {{ data.line1 }}
    </p>
  }
  @if (data.line2) {
    <p class="line-2" [ngStyle]="data.line2Color && { color: data.line2Color }">
      {{ data.line2 }}
    </p>
  }
  @if (data.line3) {
    <p class="line-3" [ngStyle]="data.line3Color && { color: data.line3Color }">
      {{ data.line3 }}
    </p>
  }
  @if (data.bullets) {
    <ul [ngStyle]="data.bulletsColor && { color: data.bulletsColor }">
      @for (bullet of data.bullets; track $index) {
        <li [class]="data.bulletsClass">{{ bullet }}</li>
      }
    </ul>
  }
</div>
<div mat-dialog-actions data-cy="dialog-actions">
  @if (data.buttonTextNo) {
    <button
      color="primary"
      mat-stroked-button
      (click)="onClick(false)"
      data-cy="button-no">
      {{ data.buttonTextNo }}
    </button>
  }
  @if (!data.buttonTextNo) {
    <div></div>
  }
  @if (data.buttonTextYes) {
    <button color="primary" mat-raised-button (click)="onClick(true)" data-cy="button-yes">
      {{ data.buttonTextYes }}
    </button>
  }
</div>
